import { create } from "zustand";
import {
  createGame,
  processAction,
  type GameState,
  type Category,
  type ColumnId,
} from "@yamber/rules-engine";

interface GameStore {
  gameState: GameState | null;
  startGame: (templateId: string, playerIds: string[]) => void;
  roll: (playerId: string) => void;
  toggleHold: (playerId: string, dieIndex: number) => void;
  announce: (playerId: string, category: Category) => void;
  score: (playerId: string, columnId: ColumnId, category: Category) => void;
  resetGame: () => void;
}

export const useGameStore = create<GameStore>((set, get) => ({
  gameState: null,

  startGame: (templateId, playerIds) => {
    const game = createGame(templateId, playerIds);
    if (game) {
      game.status = "active";
      set({ gameState: game });
    }
  },

  roll: (playerId) => {
    const { gameState } = get();
    if (!gameState) return;

    const result = processAction(gameState, { type: "ROLL", playerId });
    if (result.success && result.newState) {
      set({ gameState: result.newState });
    }
  },

  toggleHold: (playerId, dieIndex) => {
    const { gameState } = get();
    if (!gameState) return;

    const result = processAction(gameState, {
      type: "TOGGLE_HOLD",
      playerId,
      dieIndex,
    });
    if (result.success && result.newState) {
      set({ gameState: result.newState });
    }
  },

  announce: (playerId, category) => {
    const { gameState } = get();
    if (!gameState) return;

    const result = processAction(gameState, {
      type: "ANNOUNCE",
      playerId,
      category,
    });
    if (result.success && result.newState) {
      set({ gameState: result.newState });
    }
  },

  score: (playerId, columnId, category) => {
    const { gameState } = get();
    if (!gameState) return;

    const result = processAction(gameState, {
      type: "SCORE",
      playerId,
      columnId,
      category,
    });
    if (result.success && result.newState) {
      set({ gameState: result.newState });
    }
  },

  resetGame: () => {
    set({ gameState: null });
  },
}));
